<template>
  <div
    :style="{ 'z-index': getPopupZindex }"
    :class="{'alert-overlay': true, 'is-visible': isVisible, 'is-big-alert': isBig }">
    <div class="alert">
      <h2 v-if="title">
        {{ title }}
      </h2>

      <p v-if="desc && !allowHTML">
        {{ desc }}
      </p>

      <p v-if="desc && allowHTML" v-pure-html="desc"></p>

      <btn
        @click.native="ok"
        :type="buttonType()">
        {{ okLabel }}
      </btn>
    </div>
  </div>
</template>

<script>
import PopupZindex from './../mixins/PopupZindex';

export default {
  name: 'alert',
  mixins: [
    PopupZindex
  ],
  data () {
    return {
      isVisible: false,
      isBig: false,
      title: '',
      desc: '',
      okLabel: '',
      value: '',
      allowHTML: false,
      okClick: false,
      isDanger: true
    };
  },
  mounted () {
    this.$bus.$on('alert-display', this.show);
  },
  methods: {
    ok () {
      if (this.okClick) {
        this.okClick(this.value);
      }

      this.hide();
    },
    show (config) {
      this.isVisible = true;
      this.title = config.title || '';
      this.desc = config.desc || '';
      this.okLabel = config.okLabel || this.$t('common.ui.ok');
      this.okClick = config.okClick || false;
      this.allowHTML = config.allowHTML || false;
      this.isBig = config.isBig || false;

      if (typeof config.isDanger !== 'undefined') {
        this.isDanger = config.isDanger;
      } else {
        this.isDanger = true;
      }

      this.increasePopupZindex();
    },
    cancel () {
      if (this.cancelClick) {
        this.cancelClick();
      }

      this.hide();
    },
    hide () {
      this.isVisible = false;
      this.removePopupZindex();
    },
    buttonType () {
      let type = ['popup-full'];

      if (this.isDanger) {
        type.push('danger');
      }

      if (!this.isDanger) {
        type.push('success');
      }

      return type.join(' ');
    }
  },
  beforeDestroy () {
    this.$bus.$off('alert-display', this.show);
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.alert {
  background: $color-light;
  border-radius: $border-radius-small;
  box-shadow: 0 5px 5px rgba(0, 0, 0, .25);
  left: 50%;
  overflow: hidden;
  padding: 2rem 2rem 6rem 2rem;
  position: fixed;
  top: 50%;
  transform: translateX(-50%) translateY(-33.333333%);
  transition: transform .25s ease-out;
  width: 48rem;
  will-change: transform;

  &-overlay {
    background: rgba(0, 0, 0, .25);
    height: 100%;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: opacity .25s ease-out;
    width: 100vw;
    will-change: opacity;

    &.is-visible {
      opacity: 1;
      pointer-events: auto;

      .alert {
        transform: translateX(-50%) translateY(-50%);
      }
    }
  }

  h2 {
    font-weight: 400;
    margin: 0 0 2rem 0;
  }

  p {
    color: $color-text;
  }
}

@media (max-height: 720px) and (min-width: 500px) {
  .is-big-alert .alert {
    height: 95%;

    & > p {
      max-height: calc(95% - 40px);
      overflow: auto;
    }
  }
}

@media (max-width: 500px) {
  .is-big-alert .alert {
    height: 100%;
    width: 100vw;

    & > p {
      max-height: calc(100% - 80px);
      overflow: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Alert.vue